import { cn } from "@/lib/utils";
import type { InjectionDetailViewT } from "@/types/database/events";
import { Activity, ChevronRight, Crosshair, TestTube2 } from "lucide-react";
import { warningColors } from "../../../utils/warningColors";

interface Props {
    injectionDetails: InjectionDetailViewT[];
}

const InjectionDetailsList = ({ injectionDetails }: Props) => {
    if (!injectionDetails || injectionDetails.length === 0) {
        return (
            <p className="text-slate-500 text-sm">
                No injection details provided.
            </p>
        );
    }

    return (
        <div className="space-y-4">
            {injectionDetails.map((idv) => (
                <div
                    key={idv.injection_detail_id}
                    className={cn(
                        "text-sm text-slate-700 dark:text-slate-300 flex flex-col gap-y-1",
                    )}
                >
                    <span className="flex justify-start items-center gap-2">
                        <Activity size={20} />
                        {idv.side || (
                            <span className={cn(warningColors(true))}>
                                Side not specified
                            </span>
                        )}
                    </span>
                    <span className="flex flex-wrap justify-start items-center gap-1 text-nowrap">
                        <Crosshair size={20} />
                        {idv.orthopaedic_area || (
                            <span className={cn(warningColors(true))}>
                                Area not specified
                            </span>
                        )}
                        {(idv.site || idv.subsite) && (
                            <>
                                <ChevronRight size={16} />
                                {idv.site || (
                                    <span className={cn(warningColors(true))}>
                                        Site not specified
                                    </span>
                                )}
                                {idv.subsite && (
                                    <>
                                        <ChevronRight size={16} />
                                        {idv.subsite}
                                    </>
                                )}
                            </>
                        )}
                    </span>
                    <span className="flex flex-wrap justify-start items-center gap-1 text-nowrap">
                        <TestTube2 size={20} />
                        {idv.injection_substance
                            ? (
                                <>
                                    {idv.injection_substance}
                                    {idv.dose && idv.unit &&
                                        ` (${idv.dose} ${idv.unit})`}
                                </>
                            )
                            : (
                                <span className={cn(warningColors(true))}>
                                    Substance not specified
                                </span>
                            )}
                    </span>
                </div>
            ))}
        </div>
    );
};

export default InjectionDetailsList;
